import { t } from '@/features/i18n/utils';
import { createFileRoute } from '@tanstack/react-router';
import { artifactRevisionsQuery } from '@/features/artifacts/queries';
import { TimeQuarterPassIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { WorkspaceArtifactHeader } from '@/features/artifacts/components/artifact-header';
import { ArtifactVersionHistoryPage } from '@/features/artifacts/components/artifact-version-history-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/version-history',
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    await context.queryClient.infiniteQuery({
      ...artifactRevisionsQuery(params.artifactId),
      staleTime: 'static',
    });
  },
});

function RouteComponent() {
  const { artifactId } = Route.useParams();

  return (
    <>
      <WorkspaceArtifactHeader>
        <BreadcrumbPage>
          <Icon icon={TimeQuarterPassIcon} />
          {t({ en: 'Version history', nb: 'Versjonshistorikk' })}
        </BreadcrumbPage>
      </WorkspaceArtifactHeader>
      <ArtifactVersionHistoryPage artifactId={artifactId} />
    </>
  );
}
